import { ChromeSetting } from '@decisions/server/DecisionsFramework/Design/Flow/CoreSteps/ChromeSetting';

export type LeftPanelState = 'collapsed' | 'expanded' | 'hidden';
export type HeaderState = 'small' | 'full' | 'hidden';

export function isBurgerActionsBarVisible(chrome?: ChromeSetting): boolean {
  return chrome === ChromeSetting.NoTopBarHasFolderTree || chrome === ChromeSetting.NoTopBarFolderTreeCollapsed;
}

export function getLeftPanelState(chrome?: ChromeSetting): LeftPanelState {
  if (chrome == null || chrome === ChromeSetting.NoTopBarHasFolderTree) {
    return 'expanded';
  }

  if (chrome === ChromeSetting.Off || chrome === ChromeSetting.Small || chrome === ChromeSetting.TopBarOnly) {
    return 'hidden';
  }

  if (chrome === ChromeSetting.NoTopBarFolderTreeCollapsed || chrome === ChromeSetting.TopBarFolderTreeCollapsed) {
    return 'collapsed';
  }

  // console.warn(`Unknown chrome value: ${chrome}`); // 0 is a legit / common chrome value now.
  return 'expanded';
}

export function isNavigationVisible(chrome?: ChromeSetting): boolean {
  switch (chrome) {
    case ChromeSetting.Off:
    case ChromeSetting.Small:
    case ChromeSetting.NoTopBarHasFolderTree:
    case ChromeSetting.NoTopBarFolderTreeCollapsed:
      return false;

    default:
      return true;
  }
}

export function getTopBarState(chrome?: ChromeSetting): HeaderState {
  if (chrome == null || chrome === ChromeSetting.TopBarOnly || chrome === ChromeSetting.TopBarFolderTreeCollapsed) {
    return 'full';
  }

  if (chrome === ChromeSetting.Small) {
    return 'small';
  }

  if (
    chrome === ChromeSetting.Off ||
    chrome === ChromeSetting.NoTopBarHasFolderTree ||
    chrome === ChromeSetting.NoTopBarFolderTreeCollapsed
  ) {
    return 'hidden';
  }

  // console.warn(`Unknown chrome value: ${chrome}`); 0 is a legit value now...
  return 'full';
}

export function getChromeSettingFromString(param?: string | null) {
  param = param?.toUpperCase();
  switch (param) {
    case 'OFF':
      return ChromeSetting.Off;
    case 'SMALL':
      return ChromeSetting.Small;
    case 'TOPBARONLY':
      return ChromeSetting.TopBarOnly;
    case 'TOPBARFOLDERTREECOLLAPSED':
      return ChromeSetting.TopBarFolderTreeCollapsed;
    case 'NOTOPBARHASFOLDERTREE':
      return ChromeSetting.NoTopBarHasFolderTree;
    case 'NOTOPBARFOLDERTREECOLLAPSED':
      return ChromeSetting.NoTopBarFolderTreeCollapsed;
    default:
      return ChromeSetting.None;
  }
}
